import type { IssueDefinition } from "../../issue-definition";
import { ISSUE_CATEGORY } from "../../issue-enums";
import { ISSUE_OPERATOR_ACTION } from "../../issue-operator-action";

/**
 * No recent recovery point in the tenant's OWN-REGION vault.
 *
 * This is the "is anything being backed up at all" alarm. The nightly plan
 * either stopped firing or its jobs stopped completing.
 */
export const VIBE_TENANT_BACKUP_STALE = {
  category: ISSUE_CATEGORY.OBSERVABILITY,
  message:
    "No recent AWS Backup recovery point has landed in this tenant's own-region vault for its Forgejo git-repo volume — the disk holding every git repository the tenant's apps are built from. The nightly backup plan either stopped firing or its jobs stopped completing. Read from the landed recovery point rather than from a job's API response, because AWS Backup jobs are asynchronous: a green StartBackupJob and a job that failed minutes later are indistinguishable from the caller's side. Raised per tenant and cleared once a fresh recovery point appears.",
  severity: "critical",
  remedy:
    "Run the backup now. This starts an on-demand AWS Backup job into the tenant's own-region vault, the same job the nightly plan runs. If it fails immediately, AWS's own reason is shown — most commonly a job already in flight, which clears on its own. If the plan itself is missing (no protected resource found), converge the cluster first.",
  operatorAction: ISSUE_OPERATOR_ACTION.VIBE_RUN_TENANT_BACKUP_NOW
} as const satisfies IssueDefinition;
